<template>
  <div>{{QuestionData.question_id}} <component
          v-for="(item, i) in question"
          :key="i"
          v-bind:is="item.type"
          :content="item.content"
          :idx="item.idx"
          @responseevent="listenResponses">
  </component>
  </div>
</template>

<script>
    import InputComponent from "./InputComponent";
    import CheckboxComponent from "./CheckboxComponent";
    import RadioComponent from "./RadioComponent";
    import textComponent from "./textComponent";
    import SelectComponent from "./SelectComponent";
    import ImageComponent from "./ImageComponent";
    import AudioComponent from "./AudioComponent";
    import linkComponent from "./linkComponent";

    export default {
        name: "QuestionComponent",
        components: {linkComponent, InputComponent, textComponent, CheckboxComponent, RadioComponent, SelectComponent, ImageComponent, AudioComponent},
        props: {
            QuestionData: Object,
            questionId: Number,
            step: Number,
        },
        computed: {
        },
        mounted(){
            this.withInputFields(this.$props.QuestionData.question)
        },
        data(){
            return {
                question : {},
            }
        },
        methods: {
            // beakdown questions to an array of text and inputs
            withInputFields : function (text) {
                let fields = this.$props.QuestionData.fields
                let splt = text.split(/s*({.*?})s*/g);
                let reslt = splt.map( element =>  {
                    let matched = element.match(/{([^}]+)}/)
                    if(matched){
                        fields.forEach(field => {
                            if (field.id === parseInt(matched[1].split('-').pop())) {
                                element = {
                                    type: field.formType + 'Component',
                                    content: field,
                                    idx: parseInt(matched[1]),
                                }
                            }
                        })
                    }
                    if(!matched && element.length > 0){
                        element = {
                            type : 'textComponent',
                            content : {
                                text: element
                            }
                        }
                    }
                    return element
                })

                reslt = reslt.filter( element => {
                    return element !== ''
                })
                this.$data.question = reslt;
            },
            listenResponses : function (response) {
                // if (response.placementTest)
                if(typeof response.placementTest !== "undefined"){
                    // console.log(response, this.QuestionData.fields)

                  if(this.$props.step === 1){
                    this.$emit('question_responses', {
                      placementTest: true,
                      step: response.step,
                      stepId : this.$props.step,
                      result : '0.00', // just fake it, to make select of greater level
                    })
                  }else{
                    this.$emit('question_responses', {
                      placementTest: true,
                      step: response.step,
                      stepId : this.$props.step
                    })
                  }

                }else {
                    let QuestionData = this.$props.QuestionData;
                    QuestionData.fields.forEach(field => {
                        if (field.id === response.id) {
                            field.response = response.response
                        }
                    })
                    this.$emit('question_responses', {QuestionData: QuestionData, questionId: this.$props.questionId})
                }

            }

        }
    }
</script>

<style scoped>
* {
  text-align: left;
}
</style>